// src/admin/components/RecipientManager.js

import { useState } from 'react';
import * as XLSX from 'xlsx';
import { Tab, Tabs, Button, Badge } from 'react-bootstrap';
import { UsersIcon, DocumentArrowUpIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';

const RecipientManager = ({ 
    selectedRecipients, 
    onAddRecipients, 
    onClearRecipients, 
    professionals = [], 
    contactMessages = [],
    subscribers = [] // YENİ EKLENDİ: Book Subscribers verisi prop olarak alınıyor
}) => {
    const [manualInput, setManualInput] = useState('');

    // --- Excel İşlemleri ---
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const workbook = XLSX.read(bstr, { type: 'binary' });
            const wsname = workbook.SheetNames[0];
            const ws = workbook.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

            const extractedEmails = [];
            data.forEach(row => {
                row.forEach(cell => {
                    if (typeof cell === 'string' && cell.includes('@')) {
                        extractedEmails.push(cell.trim());
                    }
                });
            });
            onAddRecipients(extractedEmails);
            alert(`${extractedEmails.length} emails found in Excel.`);
            e.target.value = null; // Reset input
        };
        reader.readAsBinaryString(file);
    };

    // --- Manuel Giriş İşlemleri ---
    const handleManualSubmit = () => {
        if (!manualInput.trim()) return;

        // Virgül, noktalı virgül veya yeni satıra göre böl
        const rawEmails = manualInput.split(/[\n,;]+/);
        const validEmails = rawEmails
            .map(e => e.trim())
            .filter(e => e.includes('@') && e.includes('.')); // Basit doğrulama

        if (validEmails.length > 0) {
            onAddRecipients(validEmails);
            setManualInput(''); // Temizle
        } else {
            alert('No valid emails found.');
        }
    };

    return (
        // z-index: 1 eklenerek scroll edildiğinde navbar'ın üzerine çıkması önlendi.
        <div className="card shadow-sm sticky-top" style={{ top: '100px', zIndex: 1 }}>
            <div className="card-header bg-white py-3 border-bottom-0">
                <h5 className="mb-0 d-flex align-items-center gap-2 text-dark">
                    <UsersIcon style={{width:'24px'}} className="text-primary"/> 
                    Target Audience
                </h5>
            </div>
            
            {/* Sayaç Paneli */}
            <div className="bg-light p-4 text-center border-top border-bottom">
                <h2 className="display-4 fw-bold text-primary mb-0">{selectedRecipients.size}</h2>
                <small className="text-muted text-uppercase fw-bold" style={{fontSize: '0.75rem', letterSpacing: '1px'}}>
                    Unique Recipients
                </small>
            </div>

            <div className="card-body p-3">
                <Tabs defaultActiveKey="db" id="recipient-tabs" className="mb-3 custom-tabs nav-justified">
                    
                    {/* 1. Veritabanı */}
                    <Tab eventKey="db" title={<span title="Database Sources">Database</span>}>
                        <div className="d-grid gap-2 mt-3">
                            <Button variant="outline-primary" className="d-flex justify-content-between align-items-center" onClick={() => onAddRecipients(professionals)}>
                                <span>Approved Pros</span>
                                <Badge bg="primary" pill>{professionals.length}</Badge>
                            </Button>
                            <Button variant="outline-success" className="d-flex justify-content-between align-items-center" onClick={() => onAddRecipients(contactMessages)}>
                                <span>Msg Contacts</span>
                                <Badge bg="success" pill>{contactMessages.length}</Badge>
                            </Button>
                            {/* YENİ: Book Subscribers Butonu */}
                            <Button variant="outline-info" className="d-flex justify-content-between align-items-center" onClick={() => onAddRecipients(subscribers)}>
                                <span>Book Subscribers</span>
                                <Badge bg="info" text="dark" pill>{subscribers?.length || 0}</Badge>
                            </Button>
                        </div>
                    </Tab>

                    {/* 2. Manuel Giriş */}
                    <Tab eventKey="manual" title={<span title="Manual Entry">Manual</span>}>
                        <div className="mt-3">
                            <label className="form-label small text-muted">Paste emails (separated by comma or new line)</label>
                            <textarea 
                                className="form-control mb-2" 
                                rows="4" 
                                placeholder="alice@example.com&#10;bob@example.com"
                                value={manualInput}
                                onChange={(e) => setManualInput(e.target.value)}
                                style={{fontSize: '0.9rem'}}
                            ></textarea>
                            <Button variant="secondary" size="sm" className="w-100" onClick={handleManualSubmit}>
                                <PencilSquareIcon style={{width:'16px'}} className="me-1"/> Add Emails
                            </Button>
                        </div>
                    </Tab>

                    {/* 3. Excel Yükleme */}
                    <Tab eventKey="excel" title={<span title="Upload File">Excel</span>}>
                        <div className="mt-3 text-center p-3 border border-dashed rounded bg-light">
                            <DocumentArrowUpIcon style={{width:'32px'}} className="text-muted mb-2"/>
                            <input 
                                type="file" 
                                accept=".xlsx, .xls, .csv" 
                                className="form-control form-control-sm" 
                                onChange={handleFileUpload}
                            />
                            <small className="text-muted d-block mt-2" style={{fontSize: '0.75rem'}}>
                                Auto-extracts from any column.
                            </small>
                        </div>
                    </Tab>
                </Tabs>

                <hr className="my-4"/>
                
                <Button 
                    variant="outline-danger" 
                    size="sm" 
                    className="w-100 d-flex align-items-center justify-content-center gap-2"
                    onClick={onClearRecipients} 
                    disabled={selectedRecipients.size === 0}
                >
                    <TrashIcon style={{width:'16px'}}/> Clear All Recipients
                </Button>
            </div>
        </div>
    );
};

export default RecipientManager;